import { styled, css } from 'styled-components';
import { gradients } from '../../../abstracts/colors';
import { dontForwardProps } from '../../../util';
export const typesColors = {
  success: {
    backgroundColor: 'var(--aui-status-success-soft)',
    color: 'var(--aui-status-on-success-soft)',
    boxShadowColor: 'var(--aui-status-success)'
  },
  warn: {
    backgroundColor: 'var(--aui-status-warning-soft)',
    color: 'var(--aui-status-on-warning-soft)',
    boxShadowColor: 'var(--aui-status-warning)'
  },
  error: {
    backgroundColor: 'var(--aui-status-error-soft)',
    color: 'var(--aui-status-on-error-soft)',
    boxShadowColor: 'var(--aui-status-error)'
  },
  dark: {
    backgroundColor: 'var(--aui-inverse-surface)',
    color: 'var(--aui-inverse-on-surface)',
    boxShadowColor: 'var(--aui-inverse-on-surface)'
  },
  gradient: {
    backgroundColor: gradients.lightAngle1,
    color: '#2f3033',
    // Force gradient type to stay light in dark mode
    boxShadowColor: '#1a1c1e' // Force gradient type to stay light in dark mode
  },
  default: {
    backgroundColor: 'var(--aui-neutral-soft)',
    color: 'var(--aui-on-neutral-soft)',
    boxShadowColor: 'var(--aui-neutral)'
  }
};
const bannerStylesByType = type => css(["", ":", ";color:", ";"], type === 'gradient' ? 'background' : 'background-color', typesColors[type].backgroundColor, typesColors[type].color);
export const AlertBannerContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-vkkqwn-0"
})(["background-color:#e6e6eb;display:", ";box-sizing:border-box;flex-direction:column;width:100%;", ";", " ", ";"], ({
  isOpen
}) => isOpen ? 'flex' : 'none', ({
  alertBannerType
}) => bannerStylesByType(alertBannerType), ({
  alertBannerType,
  $display
}) => $display === 'inline' && css(["box-shadow:inset 2px 0 ", ";"], typesColors[alertBannerType].boxShadowColor), ({
  alertBannerType
}) => alertBannerType === 'gradient' && css([".aui-action-flat{color:#2f3033;}"]));